<script>
import ClickOut from '../../../../utils/directives/clickout'
import {STATUS_ABERTO} from '../../../../domain/grv/helpers/GrvStatus'
import {emitirSegundaVia, getPublicLinkS3} from '../../../../domain/grv/services'
import createDownloadLink from '../../../../utils/create-download-link'
import {GRV_POLICIA_CIVIL} from '../../../../domain/grv/helpers/tipos-grv'
import AclCheckMixins from '../../../_default/components/mixins/AclCheckMixins'

export default {
  name: 'btn-acoes-grv-roubo-furto',
  mixins: [AclCheckMixins],
  props: ['grv'],
  directives: {ClickOut},
  components: {},
  data () {
    return {
      open: false
    }
  },
  computed: {
    podeExcluirGrv () {
      const {id} = this.currentUser
      if (+this.grv.status === STATUS_ABERTO) return this.ACL.check('excluir_grv_aberta', id)
      return this.ACL.check('excluir_grv', id)
    },
    arquivoScanGrv () {
      const {arquivoScan} = this.grv
      if (!arquivoScan || !Array.isArray(arquivoScan) || !arquivoScan.length) return null
      return arquivoScan[0]
    }
  },
  mounted () {},
  destroyed () {
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    hide () {
      this.open = false
    },
    openRetirada () {
      if (!this.grv.ggv) {
        alert('É necessário cadastrar uma GGV antes.')
        return
      }
      this.$router.push({name: 'roubo-furto.visualizar.patio', params: {id: this.grv.id}})
    },
    deleteGrv () {
      this.$emit('excluirGrv', this.grv.id)
    },
    emitirSegundaVia () {
      this.$bar.start()
      this.$loaderOverlay.open().message('Gerando documento, aguarde...')
      const {id, numero} = this.grv
      emitirSegundaVia(id).then((response) => {
        let callbackEnd = () => {
          createDownloadLink(response.data, `grv_${numero}.pdf`)
          this.$bar.finish()
          this.$loaderOverlay.hide()
        }
        callbackEnd()
      }).catch((response) => {
        this.$bar.finish()
        this.$loaderOverlay.hide()
        this.cadastroError = response.data.errors
        this.$nextTick(() => {
          this.$refs.error.focus()
        })
        console.log(response)
      })
    },
    criarGgv () {
      const {grv} = this
      this.$router.push({name: 'roubo-furto.visualizar.ggv', params: {id: grv.id}, query: {ggv: 1, tipoGrv: GRV_POLICIA_CIVIL}})
    },
    bloquearParaLeilao () {
      this.$emit('bloquearParaLeilao', this.grv.id)
    },
    downloadDocumento () {
      this.$loaderOverlay.open()
      const arquivo = this.arquivoScanGrv
      getPublicLinkS3(arquivo.id)
        .then(response => {
          const link = document.createElement('a')
          link.href = `${process.env.API_URL}${response.data}`
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$loaderOverlay.hide()
        })
        .catch(error => {
          alert('Ocorreu um erro ao acessar a imagem, tente novamente')
          this.$loaderOverlay.hide()
          console.log(error)
        })
    }
  }
}
</script>

<template>
  <div class="btn-group dropdown" :class="{open}" v-click-out="hide">
    <a @click="emitirSegundaVia" class="btn btn-info btn-xs">Emitir GRV</a>
    <button type="button" class="btn btn-info btn-xs dropdown-toggle" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle">
      <span class="caret"></span>
      <span class="sr-only">Toggle Dropdown</span>
    </button>
    <ul class="dropdown-menu dropdown-menu-right no-padder">
      <li>
        <a @click="emitirSegundaVia"><i class="fa fa-file-pdf-o m-r-xs"></i> Emitir GRV Completa</a>
      </li>
      <li  v-if="grv.status > 99 && grv.status < 200">
        <a @click="$emit('emitirDocumentoRetirada', grv)"><i class="fa fa-file-pdf-o m-r-xs"></i> Emitir PDF Retirada</a>
      </li>
      <li>
        <a @click="$emit('openDeclaracaoAcessoVeiculo', grv)"><i class="fa fa-file-pdf-o m-r-xs"></i> Declaração de Acesso ao Veículo</a>
      </li>
      <li v-if="arquivoScanGrv">
        <a @click="downloadDocumento"><i class="fa fa-file-pdf-o m-r-xs"></i> Emitir Scan GRV</a>
      </li>
      <li class="separator"></li>
      <li>
        <a v-if="ACL.check('criar_ggv_policia', currentUser.id)" @click="criarGgv"><i class="fa fa-file-o m-r-xs"></i> Vistoria (GGV)</a>
      </li> <!-- :class="{'disabled': grv.status > 1}" -->
      <li>
        <a @click="openRetirada"><i class="fa fa-file-o m-r-xs"></i> Retirada (GEV)</a>
      </li> <!-- :class="{'disabled': grv.status > 1}" -->
      <li class="separator"></li>
      <li>
        <a @click="$emit('verHistoricoDeLeiloes', grv)"><i class="fa fa-gavel"></i> Histórico de Leilões</a>
      </li>
      <li v-if="isAdministradorExclusivo" >
        <a @click="bloquearParaLeilao">
          <span :class="{'text-danger': !grv.bloqueadoParaLeilao}">
            <i :class="`fa fa-${grv.bloqueadoParaLeilao ? 'check' : 'ban'}`"></i> {{ grv.bloqueadoParaLeilao ? 'Desbloquear ' : 'Bloquear' }} para leilões
          </span>
        </a>
      </li>
      <li>
        <a class="text-danger" @click="deleteGrv" v-if="podeExcluirGrv"><span class="text-danger"><i class="fa fa-remove"></i> Excluir GRV</span></a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.separator {
  border: 1px solid rgba(149, 175, 192, .5);
  margin: 7px auto;
}
</style>



// WEBPACK FOOTER //
// BtnAcaoListaGrvRouboFurto.vue?e0a2df38